import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';

import { settingsWrapperComponent } from 'site-modules/profile/components/settings/settings-wrapper/settings-wrapper';
import { Link } from 'site-modules/shared/components/link/link';

export function PrivacyRequestUI({ profileData, privacy = null }) {
  const preventThirdPartySharing = get(profileData, 'meta.preventThirdPartySharing', privacy?.doNotSell);

  return (
    <>
      {preventThirdPartySharing
        ? `You have opted out of the sale and sharing of personal information. To submit a privacy request, please
              visit our request submission page at `
        : `You have not opted out of the sale and sharing of personal information. If you wish to opt out or submit
              another type of privacy request, please visit our request submission page at `}
      <Link className="text-underline" to="/data-privacy-request/">
        https://www.edmunds.com/data-privacy-request/
      </Link>
      .
    </>
  );
}

PrivacyRequestUI.propTypes = {
  profileData: PropTypes.shape({}).isRequired,
  privacy: PropTypes.shape({
    uspString: PropTypes.string,
    doNotSell: PropTypes.bool,
  }),
};

export const PrivacyRequest = settingsWrapperComponent(PrivacyRequestUI);
